import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import { WarningCircle } from '@app/sharedComponents/Icons/Icons';
import ROUTE from '@app/navigationApp/routes';
import { formatIndianCurrency } from '@app/utils/utility';
import { Info } from '@app/sharedComponents/Icons/Icons';
import dayjs from 'dayjs';
import { REPAYMENT_COLLECTION_TYPE } from '@app/utils';
import FaqContainer from './FaqContainer/FaqContainer';
import { endpoints } from '@app/api/apis';
import axios from 'axios';
import fetchUserDetails from '@app/helper/fetchUserInfo';
import { useState } from 'react';

const LoanExpiredCard = ({creditInfo,navigation,contactNumber,showFaqs=true}) => {
    const {renewalDate,creditId} = creditInfo || {};
    // const renewalDate = dayjs('2025-03-20');
    const expiryDate = dayjs(renewalDate);
    const outstandingDueAmount = creditInfo?.netPayable??0;
    const numberOfdaysFromExpiry = Math.floor(expiryDate.diff(dayjs(), 'day',true));
    const lastRepaymentDate = dayjs(renewalDate).add(6,'day');
    const [buttonLoader, setButtonLoader] = useState(false);
    
    const reOpenAccount = () =>{
      setButtonLoader(true)
      const url = endpoints.reopenAccount+creditId
      axios.post(url,{})
      .then((response) => {
        fetchUserDetails();
        navigation.navigate(ROUTE.LOADING)
      }
      ).catch((error) => {
        console.log('Error:', error);
      }).finally(()=>{
        setButtonLoader(false)
      });
    }

    const getInfoSection = ()=>{
      if(numberOfdaysFromExpiry > 30){
        return {
          text:``,
          subText:'',
          onPress:()=>{},
          ctaLabel:'Reopen loan account',
          ctaAction:reOpenAccount,
          ctaType:'SOLID'
        }
      }
      else if(outstandingDueAmount === 0){
        return {
          text:'Loan closure request will be raised in 1-3 business days. For any queries',
          subText:' Contact us',
          onPress:()=>{navigation?.navigate(ROUTE.CONTACT_US)},
          ctaLabel:'',
          ctaAction:()=>{},
          ctaType:'SOLID'
        }
      }
      else if(outstandingDueAmount < 0){
        return {
          text:'Raise refund request and close your loan.',
          subText:'',
          onPress:()=>{navigation?.navigate(ROUTE.CONTACT_US)},
          ctaLabel:'Close loan and get refund',
          ctaAction:()=>{navigation?.navigate(ROUTE.CONFIRM_PAYMENT_DETAILS,{selectedAmount:outstandingDueAmount,paymentType:REPAYMENT_COLLECTION_TYPE.FORECLOSURE,isFromForeclosure:true})},
          ctaType:'SOLID'
        }
      }
      else{
        if(numberOfdaysFromExpiry<7){
          return {
            text:`Clear dues by ${dayjs(lastRepaymentDate).format('DD MMM, YYYY')} to avoid portfolio sell-off.`,
            subText:' Contact us',
            onPress:()=>{navigation?.navigate(ROUTE.CONTACT_US)},
            ctaLabel:'Clear dues',
            ctaAction:()=>{navigation?.navigate(ROUTE.FLEXI_PAY,{isLoanRenewal:true,paymentAmount:outstandingDueAmount,paymentType:REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT})},
            ctaType:'SOLID'
          }
        } else if(numberOfdaysFromExpiry>7 && numberOfdaysFromExpiry<30){
          return {
            pretext:`Repayment was due on  ${dayjs(lastRepaymentDate).format('DD MMM, YYYY')}`,
            text:'Portfolio sell-off may have been initiated. Still want to repay?',
            subText:'Clear dues',
            onPress:()=>{navigation?.navigate(ROUTE.FLEXI_PAY,{isLoanRenewal:true,paymentAmount:outstandingDueAmount,paymentType:REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT})},
            ctaLabel:' Contact support',
            ctaAction:()=>{navigation?.navigate(ROUTE.CONTACT_US)},
            ctaType:'SOLID'
          }
        } else{
          return {
            text:``,
            subText:'',
            onPress:()=>{},
            ctaLabel:'Reopen loan account',
            ctaAction:reOpenAccount,
            ctaType:'SOLID'
          }
        }
      }
    }
    const infoSection = getInfoSection();
    return(
    <>
    <ThemedView mx='lg' p='lg' mt='2xl'  borderColor='border-primary' backgroundColor='bg-fill-primary' borderWidth={1} borderRadius='lg'>
        <ThemedView flexDirection='row' mb='lg' alignItems='center'>
          <WarningCircle size={25} weight="fill" color='#DE4043'/>
        <ThemedText color='text-primary' ml='sm' variant='h5s'>
          Loan expired on {dayjs(renewalDate).format('Do MMM, YYYY')}
        </ThemedText>
        </ThemedView>
        <ThemedText color='text-secondary' mb='2xs' variant='b4r' >
          {outstandingDueAmount>0 ? 'Overdue amount' :
           outstandingDueAmount<0 ? 'Outstanding amount':'Credit limit'}</ThemedText>
           {
            numberOfdaysFromExpiry>30 ? 
            <ThemedView flexDirection='row' alignItems='center' mb='lg'>
            <ThemedText variant='l1'color='text-primary' >₹</ThemedText>
            <ThemedText color='text-primary' variant='h1b'>
            {formatIndianCurrency(creditInfo?.actualLoanAmount)}
            </ThemedText>
          </ThemedView>:
             <ThemedView flexDirection='row' alignItems='center' mb='lg'>
             <ThemedText variant='l1'color={outstandingDueAmount>0 ? 'text-error':'text-primary'} >₹</ThemedText>
             <ThemedText color={outstandingDueAmount>0 ? 'text-error':'text-primary'} variant='h1b'>
             {formatIndianCurrency(outstandingDueAmount===0 ?creditInfo?.actualLoanAmount : outstandingDueAmount)}
             </ThemedText>
           </ThemedView>
           }
     

        {infoSection?.pretext && 
        <ThemedText color='text-secondary' mb='md' variant='b4r'>
          {infoSection?.pretext}
        </ThemedText>
        }
        {infoSection?.text &&<ThemedView backgroundColor='bg-fill-info' p='sm' flexDirection='row' alignItems='center' borderRadius='sm' mb='md'>
          <Info weight="fill" color={themeColorSet['icon-secondary']} size={20}/>
           <ThemedText variant='b4m' color='text-secondary' ml="sm" flexShrink={1} >
          {infoSection?.text}
          {infoSection?.subText &&
            <ThemedText variant='b4b' color='text-action-primary' onPress={infoSection?.onPress}>
              {infoSection?.subText}
            </ThemedText>
          }
          </ThemedText>
        </ThemedView>}
        {infoSection?.ctaLabel && <Button eventName='LOAN_EXPIRED' additionalProperties={{label:infoSection?.ctaLabel}}  buttonLoader={buttonLoader} label={infoSection?.ctaLabel} size="MD" type={infoSection?.ctaType??'SOLID'} handlePress={infoSection?.ctaAction}/>}
    </ThemedView>
    {showFaqs && <FaqContainer lender={creditInfo?.lendingPartnerId} contactNumber={contactNumber}/>}
    </>
    )
}

export default LoanExpiredCard;